module.exports = __webpack_public_path__ + "static/img/diy-auto.48ea0a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/reformat/diy-auto.png
// module id = Ou3t
// module chunks = 0